import dayjs from 'dayjs'
import config from 'config'
import $t from '../i18n'
import { CLAIM_STATUS_CODES } from '../consts/ClaimsConsts'
export const formattedClaimId = claimId => {
  // remove leading zeros
  return claimId?.replace(/^0{4,}/, '') || ''
}

export const getClaimFormattedDate = date => {
  return date ? dayjs(date).format(config.claimsDateFormat) : '-'
}

export const getClaimStatusByCode = statusCode => {
  if (!statusCode) {
    return '-'
  }

  switch (statusCode) {
    case CLAIM_STATUS_CODES.IN_REVIEW:
    case CLAIM_STATUS_CODES.RECEIVED_IN_PROCESS:
      return $t('pages.claims.receivedInProcess')
    // A reversed pharmacy fill renders every amount as $0.00, so without its
    // own label it reads as a processed claim the plan paid nothing towards.
    case CLAIM_STATUS_CODES.REVERSED:
      return $t('pages.claims.reversed')
    default:
      return $t('pages.claims.processed')
  }
}
